module.exports = __webpack_public_path__ + "img/2012-08-18 09.12.32.9160d199.jpg";